<div class="element-form-container dsforms-element-paragraph-container no-bottom-pad" qa="paragraph-element">
    <div class="paragraph-text" [innerHTML]="paragraphHtml" qa="paragraph-text"></div>
</div>
